(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.inrev-nav
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn inrev-nav
  [{:keys [report-data] :as props}]
  (report-ctl/with-footnote
   props
   :inrev-nav-footnotes
   (:inrev-nav report-data)))
